import PropTypes from 'prop-types';
import defaultLoadingVideo from '../../video/loading-loop.gif';
import { StyledGifSpinner } from './styles';

export default function Spinner({ size, videoSrc = defaultLoadingVideo }) {
  return (
    <StyledGifSpinner size={size}>
      <img src={videoSrc} alt="Loading..." width={size} height={size} />
    </StyledGifSpinner>
  );
}

Spinner.propTypes = {
  size: PropTypes.number.isRequired,
  videoSrc: PropTypes.string.isRequired, // agora será o caminho do GIF
};
